/**
 * Display formatting for matchmaking price quotes.
 *
 * Legacy package_price_histories.currency='rial' amounts are historically Toman
 * and are emitted by V2 quotes as IRT (no ÷10).
 * True IRR amounts (rare) remain Rial units and display as Toman via ÷10.
 * Unknown currencies are left undivided and not labeled as Toman.
 */

function toFaDigits(value) {
  return String(value).replace(/\d/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'[digit])
}

function formatFaAmount(value) {
  const grouped = String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '٬')
  return toFaDigits(grouped)
}

function normalizeCurrency(currency) {
  return String(currency == null ? '' : currency).trim().toUpperCase()
}

export function priceTierLabel(tier, lang = 'fa') {
  const match = /^tier_([1-3])$/i.exec(String(tier || ''))
  if (!match) return String(tier || '')
  return lang === 'en' ? 'Price band ' + match[1] : 'سطح تعرفه ' + toFaDigits(match[1])
}

function isTrueRialCurrency(code) {
  return code === 'IRR'
}

/**
 * @param {number|string} amount
 * @param {string} [currency]
 * @returns {{
 *   text: string,
 *   displayAmount: number,
 *   rawAmount: number,
 *   currency: string,
 *   unit: 'toman'|'currency'|'raw',
 *   isToman: boolean,
 * }}
 */
export function formatMoneyForDisplay(amount, currency) {
  const raw = Number(amount)
  const rawAmount = Number.isFinite(raw) ? raw : 0
  const code = normalizeCurrency(currency)

  // True Rial (IRR) → display Toman via ÷10.
  if (isTrueRialCurrency(code)) {
    const displayAmount = Math.round(rawAmount / 10)
    return {
      text: formatFaAmount(displayAmount),
      displayAmount,
      rawAmount,
      currency: code,
      unit: 'toman',
      isToman: true,
    }
  }

  // Legacy V2 quotes use IRT/TOMAN for historically Toman-denominated amounts.
  // Bare 'RIAL' from older clients is treated the same (no ÷10) once the API emits IRT.
  if (code === 'TOMAN' || code === 'IRT' || code === 'RIAL') {
    return {
      text: formatFaAmount(rawAmount),
      displayAmount: rawAmount,
      rawAmount,
      currency: code === 'RIAL' ? 'IRT' : code,
      unit: 'toman',
      isToman: true,
    }
  }

  if (code) {
    return {
      text: formatFaAmount(rawAmount),
      displayAmount: rawAmount,
      rawAmount,
      currency: code,
      unit: 'currency',
      isToman: false,
    }
  }

  return {
    text: formatFaAmount(rawAmount),
    displayAmount: rawAmount,
    rawAmount,
    currency: '',
    unit: 'raw',
    isToman: false,
  }
}
